import { 
  Home, 
  Users, 
  Gamepad2, 
  HelpCircle, 
  Settings, 
  LayoutDashboard, 
  Calendar, 
  Clock, 
  ShoppingCart,
  Crosshair,
  BookOpen,
  CreditCard,
  UserRound,
  Wallet,
  MessageSquare,
  DollarSign,
  TrendingUp,
  Image,
  Group,
  UsersRound,
  Crown,
  Star
} from "lucide-react";

const iconMap = {
  home: Home,
  users: Users,
  gamepad: Gamepad2,
  help: HelpCircle,
  settings: Settings,
  dashboard: LayoutDashboard,
  calendar: Calendar,
  clock: Clock,
  shopping: ShoppingCart,
  crosshair: Crosshair,
  book: BookOpen,
  credit: CreditCard,
  user: UserRound,
  wallet: Wallet,
  message: MessageSquare,
  dollar: DollarSign,
  trending: TrendingUp,
  image: Image,
  group: Group,
  communities: UsersRound,
  crown: Crown,
  star: Star
};

export const getIcon = (iconName: string) => {
  return iconMap[iconName as keyof typeof iconMap] || Home;
}; 